import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the state type for tab management
interface TabState {
  activeTab: string;
  tabs: { [key: string]: any };
  tabNames: string[];
  isLoading?: boolean;
  showTabs: boolean;
}


// Set initial state with default tab
const initialState: TabState = {
  activeTab: "",
  tabs: {},
  tabNames: [],
  showTabs: true,
};

const tabSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    // Set active tab
    setActiveTab: (state: TabState, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },

    addTabs: (state: TabState, action: PayloadAction<object>) => {
      state.tabs = action.payload;
      state.tabNames = Object.keys(action.payload);
      state.activeTab =
        new URLSearchParams(window.location.search).get("tab") ||
        Object.keys(action.payload)[0];
    },
    setShowTabs: (state, action: PayloadAction<boolean>) => {
      state.showTabs = action.payload;
    },
  },
});

export const { setActiveTab, addTabs, setShowTabs } = tabSlice.actions;
export default tabSlice.reducer;
